import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import InputName from "../../common/Input/InputName";

const AddUpdateClientType = ({
    showModal,
    setModalVisible,
    formData,
    handleChange,
    modalAction,
    handleAddOrUpdateClientType,
    setInputError
}) => {

    return (
        <Modal show={showModal} onHide={() => setModalVisible(false)} centered size="md">
            <div className="modal-header">
                <h5 className="modal-title">
                    {modalAction === "create" ? "Add Client Type" : "Edit Client Type"}
                </h5>
                <button
                    type="button"
                    className="btn-close"
                    onClick={() => setModalVisible(false)}
                ></button>
            </div>
            <div className="modal-body">
                <Form onSubmit={handleAddOrUpdateClientType}>
                    <div className="row">
                        {/* Client Type Name Input */}
                        <div className="col-xl-12">
                            <div className="form-group">
                                <InputName
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    placeholder="Enter client type name"
                                    label="Name"
                                    setInputNameError={setInputError}
                                    required={true}
                                />
                            </div>
                        </div>

                        {/* Status Radio Buttons */}
                        <div className="col-xl-12">
                            <div className="form-group d-flex align-items-center">
                                <label htmlFor="status" className="col-form-label me-3">
                                    Status:
                                </label>
                                <div className="form-check me-3">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="status"
                                        id="statusActive"
                                        value="Active"
                                        checked={formData.status === "Active"}
                                        onChange={handleChange}
                                    />
                                    <label className="form-check-label" htmlFor="statusActive">
                                        Active
                                    </label>
                                </div>
                                <div className="form-check me-3">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="status"
                                        id="statusInactive"
                                        value="Inactive"
                                        checked={formData.status === "Inactive"}
                                        onChange={handleChange}
                                    />
                                    <label className="form-check-label" htmlFor="statusInactive">
                                        Inactive
                                    </label>
                                </div>
                                <div className="form-check me-3">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="status"
                                        id="statusDelete"
                                        value="Deleted"
                                        checked={formData.status === "Deleted"}
                                        onChange={handleChange}
                                    />
                                    <label className="form-check-label" htmlFor="statusDelete">
                                        Delete
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <Button
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => setModalVisible(false)}
                        >
                            Close
                        </Button>
                        <Button type="submit" className="btn btn-success">
                            {modalAction === "create" ? "Add Client Type" : "Update Client Type"}
                        </Button>
                    </div>
                </Form>
            </div>
        </Modal>
    );
};

export default AddUpdateClientType;
